import { useCurrentWorkspace } from '@gripp/shared-logic';
import { AlertsManagementSearchInput, AlertsManagementList, FilterType } from '@gripp/shared-ui';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FilterBar } from '../../shared/components/filter/filterBar';
import { useMaxHeight } from '../../shared/hooks/useMaxHeight';

export const AlertsManagement = () => {
  const { containerMaxHeight, listMaxHeight } = useMaxHeight(64, 0, 228);
  const workspace = useCurrentWorkspace();

  if (!workspace) {
    return null;
  }

  return (
    <>
      <View style={[styles.filtersContainer, { maxHeight: containerMaxHeight }]}>
        <View style={styles.searchContainer}>
          <AlertsManagementSearchInput />
        </View>
        <FilterBar
          filterButtonTypes={[FilterType.ALERTSMANAGEMENTCOLUMNS]}
        />
      </View>
      <View style={styles.tableContainer}>
        <AlertsManagementList maxHeight={listMaxHeight} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 44,
    marginBottom: 20,
  },
  searchContainer: {
    width: 390,
    marginRight: 20,
  },
  tableContainer: {
    flex: 1,
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: -1,
  },
});
